import type { Courier } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

export interface CourierFormState {
  id?: GQL_ID
  firstName: string
  lastName: string
  phone: string
  status: number

  shopIds?: GQL_ID[]
  deliveryZoneIds?: GQL_ID[]

  is_shift_require_confirmation: boolean
}

export const PROMOCODE_DEFAULT_STATE: CourierFormState = {
  id: undefined,
  firstName: '',
  lastName: '',
  phone: '',
  status: 0,

  shopIds: [],
  deliveryZoneIds: [],

  is_shift_require_confirmation: false
}

export const makeCourierFormState = (courier?: Courier): CourierFormState => {
  return mapApiDataToState(courier ?? {})
}

// state and api variable are same excluding info fields
// so drop them and go
export const mapStateToApiVariable = (state: CourierFormState): any => ({
  id: state.id,
  first_name: state.firstName,
  last_name: state.lastName,
  phone: state.phone,
  status: Number(state.status) ?? 0,
  shopIds: state.shopIds,
  deliveryZoneIds: state.deliveryZoneIds,
  is_shift_require_confirmation: state.is_shift_require_confirmation
})

export const mapApiDataToState = (data: Courier): CourierFormState => ({
  id: data.id,
  firstName: data.first_name,
  lastName: data.last_name,
  phone: data.phone,
  status: data.status,
  shopIds: data.shops?.map(shop => Number(shop.id)) ?? [],
  deliveryZoneIds: data.deliveryZones?.map(zone => Number(zone.id)) ?? [],
  is_shift_require_confirmation: data.is_shift_require_confirmation ?? false
})
